import React, { useEffect, useState, useImperativeHandle } from 'react'
import DataSheet from './dataSheet'
import { handleSave } from './handleSave'

const fields = [
  'accountType',
  'accountCode',
  'accountName',
  'centerCode',
  'centerName'
]
export default function Spreadsheet () {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_KEY}/spreadsheet/glAccount`, {
      method: 'GET',
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(async response => {
        const headers = [{ value: '', readOnly: true }]
        for (const field of fields) {
          headers.push({ value: field, readOnly: true })
        }
        const grid = [[...headers]]
        const { data } = await response.json()
        let index = 0
        for (const obj of data) {
          index = index + 1
          const data = [{ value: index, readOnly: true }]
          for (const field of fields) {
            data.push({ value: obj[field] })
          }
          grid.push([...data])
        }
        setData(grid)
        setRefresh(false)
      })
      .catch(err => {
        console.log(err)
        setRefresh(false)
      })
  }, [refresh])

  return (
    <div>
      <DataSheet
        data={data}
        refresh={() => setRefresh(true)}
        save={data => handleSave(data, fields, 'glAccount')}
      />
    </div>
  )
}
